<template>
    <el-dialog v-model="data.currentImageVisible"><img style="width:100%" :src="data.currentImage[0].url"
            alt="预览图" /></el-dialog>
    <el-dialog title="修改稿件信息" v-model="data.editVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" style="padding-bottom: 2rem" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="日期">
                <el-input v-model="editInfo.date" />
            </el-form-item>
            <el-form-item label="编号">
                <el-input v-model="editInfo.id" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="editInfo.sort" />
            </el-form-item>
            <el-form-item label="作者">
                <el-input v-model="editInfo.author" />
            </el-form-item>
            <el-form-item label="稿价">
                <el-input v-model.number="editInfo.price" type="number" />
            </el-form-item>
            <el-form-item label="关联角色">
                <el-autocomplete v-model="data.charaAutoCompleteValue" :fetch-suggestions="querySearch" clearable
                    @select="handleSelect" />
                <!-- <el-input v-model.number="editInfo.chara" /> -->
            </el-form-item>
            <el-form-item label="关联服设">
                <el-input v-model="editInfo.closet" />
            </el-form-item>
            <el-form-item label="是否精选">
                <el-input v-model="editInfo.favourite" />
            </el-form-item>
            <el-form-item label="是否g向">
                <el-input v-model="editInfo.guro" />
            </el-form-item>
            <el-form-item label="更新时间">
                <el-input v-model="editInfo.updateTime" disabled />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="新增稿件信息" v-model="data.createVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" style="padding-bottom: 2rem" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="日期">
                <el-input v-model="editInfo.date" />
                <!-- <el-date-picker-panel v-model="editInfo.date" /> -->
            </el-form-item>
            <el-form-item label="排序">
                <el-input v-model="editInfo.sort" />
            </el-form-item>
            <el-form-item label="作者">
                <el-input v-model="editInfo.author" />
            </el-form-item>
            <el-form-item label="稿价">
                <el-input v-model.number="editInfo.price" type="number" />
            </el-form-item>
            <el-form-item label="关联角色">
                <el-input v-model.number="editInfo.chara" />
            </el-form-item>
            <el-form-item label="关联服设">
                <el-input v-model="editInfo.closet" />
            </el-form-item>
            <el-form-item label="是否精选">
                <el-input v-model="editInfo.favourite" />
            </el-form-item>
            <el-form-item label="是否g向">
                <el-input v-model="editInfo.guro" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="删除稿件信息" v-model="data.deleteVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item>
                是否删除相关稿件信息？
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">确认</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-button type="primary" @click="handleCreate">新增</el-button>
    <el-table :data="commissionList.commissionInfo" stripe border>
        <el-table-column show-overflow-tooltip prop="id" label="编号" />
        <el-table-column show-overflow-tooltip label="图片预览">
            <template #default="scope">
                <el-image style="width: 100%" :src="getImage(scope.row.date, scope.row.sort)" show-progress
                    fit=" cover" />
            </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="date" label="日期" />
        <el-table-column show-overflow-tooltip prop="sort" label="排序" />
        <el-table-column show-overflow-tooltip prop="author" label="作者" />
        <el-table-column show-overflow-tooltip prop="price" label="稿价" />
        <el-table-column show-overflow-tooltip label="关联角色">
            <template #default="scope">
                {{ charaNameList[scope.row.chara] ||
                    `(${scope.row.chara})` }}
            </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="closet" label="关联服设">

        </el-table-column>
        <el-table-column show-overflow-tooltip prop="favourite" label="是否精选" />
        <el-table-column show-overflow-tooltip prop="guro" label="是否g向" />
        <el-table-column show-overflow-tooltip prop="status" label="状态" />
        <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" />
        <el-table-column label="操作" fixed="right" width="250">
            <template #default="scope">
                <el-button type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="default" @click="handleEnable(scope.$index, scope.row)">{{ scope.row.status ===
                    0 ? "启用" : "禁用" }}</el-button>
                <el-button type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination v-if="commissionList" layout="prev, pager, next" :current-page="data.currentPage"
        :size="data.pagesize" :total="commissionList.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
</template>
<script setup>
import { ref, onMounted } from 'vue';

import service from '@/utils/request.js'
import { Plus } from '@element-plus/icons-vue'
import axios from 'axios'


const suffixes = ['.jpg', '.jpeg', '.png', '.gif']
const ga = ref(

)
const handlePreview = () => {
    data.value.currentImageVisible = true
}

const handleRemove = () => {
    data.value.uploadFile = null;
    $('.el-upload').css('display', 'flex');
}

const handleFileChange = (file, newFileList) => {
    data.value.currentImage = newFileList;
    data.value.uploadFile = file.raw;
    if (data.value.currentImage.length > 0) {
        $('.el-upload').css('display', 'none');
    }
};


const editInfo = ref({
    date: null,
    sort: null,
    chara: null,
    price: 0,
    closet: null,
    favourite: 0,
    guro: 0,
    status: 1,
    updateTime: null,
    id: null,
    author: null
})
const originInfo = ref()
const commissionList = ref({})

const props = defineProps({
    employee: {
        type: Object,
        default: {}
    },
    parentCurrentPage: {
        type: Number
    },
    charaNameList: {
        type: Object
    },
})
const data = ref({
    submit_button_disabled: false,
    loading: false,
    currentPage: 1,
    pagesize: 10,
    editVisible: ref(false),
    createVisible: ref(false),
    deleteVisible: ref(false),
    currentImageVisible: ref(false),
    currentImage: ref([]),
    uploadFile: ref(),
    charaAutoCompleteValue: ''
});

const querySearch = (queryString, callback) => {
    let results = [];
    Object.entries(props.charaNameList).forEach(([id, name]) => {
        if (name.toLowerCase().includes(queryString.toLowerCase())) {
            results.push({
                id: Number(id),
                value: name
            });
        }
    })
    callback(results);
}

const handleSelect = (item) => {
    data.value.charaAutoCompleteValue = item.value;
    editInfo.value.chara = item.id;
}

const handleEdit = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    originInfo.value = JSON.parse(JSON.stringify(row));
    data.value.charaAutoCompleteValue = props.charaNameList[row.chara];
    data.value.editVisible = true;
}

const handleDelete = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    data.value.deleteVisible = true;
}

const handleCreate = () => {
    data.value.createVisible = true;
    resetEditInfo();
}

const cancel = () => {
    data.value.editVisible = false;
    data.value.createVisible = false;
    data.value.deleteVisible = false;
    resetEditInfo();
}

const submit = async () => {
    if (data.value.editVisible) {
        if (JSON.stringify(editInfo.value) === JSON.stringify(originInfo.value)) {
            data.value.editVisible = false;
        }
        try {
            // 表格校验
            data.loading = true;
            if (data.value.uploadFile) {
                const formData = new FormData();
                formData.append('file', data.value.uploadFile);
                try {
                    const uploadRes = await service.post("/admin/common/upload", formData);
                    if (uploadRes.data != false) {
                        editInfo.value.image = uploadRes.data;
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }

            try {
                const uploadPropertyRes = await service.put("/admin/commission", editInfo.value);
                if (uploadPropertyRes.data != false) {
                    data.loading = false;
                } else {
                    data.loading = false;
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
            data.value.editVisible = false;
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.createVisible) {
        if (data.value.uploadFile) {
            const formData = new FormData();
            formData.append('file', data.value.uploadFile);
            try {
                const uploadRes = await service.post("/admin/common/upload", formData);
                if (uploadRes.data != false) {
                    editInfo.value.image = uploadRes.data;
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            // 表格校验
            data.loading = true;
            editInfo.value.updateTime = new Date();
            const res = await service.post("/admin/commission", editInfo.value)
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.createVisible = false;
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.deleteVisible) {
        try {
            // 表格校验
            data.loading = true;
            const res = await service.delete("/admin/commission", {
                params: {
                    id: editInfo.value.id
                }
            })
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.deleteVisible = false;
        } catch (error) {
            console.log(error);
        }
    }

}

const handleEnable = async (id, row) => {
    try {
        const status = row.status === 1 ? 0 : 1;
        const url = `/admin/commission/status/${status}`;
        const res = await service.post(url, null, {
            params: {
                id: row.id
            }
        });
        if (res.data != false) {
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } else {
            console.log(error);
        }
    } catch (error) {
        console.log(error);
    }
}

const handleCurrentChange = (val) => {
    data.value.currentPage = val;
    handleRefresh(data.value.currentPage, data.value.pagesize);
}

const handleSizeChange = (val) => {
    return
}

const resetEditInfo = () => {
    editInfo.value = {
        date: null,
        sort: null,
        chara: null,
        price: 0,
        closet: null,
        favourite: 0,
        guro: 0,
        status: 1,
        updateTime: null,
        id: null,
        author: null
    };
    data.value.uploadFile = null;
    data.value.currentImage = [];
    $('.el-upload').css('display', 'flex');
}

const convertDate = (dateString) => {
    // 创建Date对象
    const date = new Date(dateString);

    // 获取年份后两位
    const year = String(date.getFullYear());

    // 获取月份（注意月份从0开始，需要+1）
    const month = String(date.getMonth() + 1).padStart(2, '0');

    // 获取日期
    const day = String(date.getDate()).padStart(2, '0');

    // 拼接成目标格式
    return `${year}-${month}-${day}`;
}

const getCommissionList = (currentPage, pagesize) => {
    const params = {
        page: currentPage,
        pageSize: pagesize
    };
    service.get("/admin/commission/page", { params })
        .then(res => {
            const total = res.data.total;
            const rst = res.data.records;
            if (rst.length != 0 && rst[0] != null) {
                let colName = Object.keys(rst[0]);
                const mapping = {
                    'date': '日期',
                    'sort': '排序',
                    'chara': '关联角色',
                    'closet': '关联服设',
                    'favourite': '是否精选',
                    'guro': '是否g向',
                    'status': '状态',
                    'image': '图片位置',
                    'createTime': '创建时间',
                    'updateTime': '更新时间',
                    'createUser': '创建者',
                    'updateUser': '更新者',
                    'id': '编号'
                };
                // 使用map方法根据映射关系替换元素
                let colLabel = colName.map(item => mapping[item] || item);
                for (let i = 0; i < rst.length; i++) {
                    const images = Object.values(require.context("img", true, /.*/).keys());
                    for (let j = 0; j < images.length; j++) {
                        if (images[j].includes(rst[i].image)) {
                            let q = images[j].replace(/^.\//, '');
                            rst[i].image = require(`img/${q}`);
                        }
                    }
                }
                commissionList.value = { commissionInfo: rst, colName: colName, colLabel: colLabel, total: total };
            } else {
                console.error('返回稿件信息为空', error);
            }

        }).catch(error => {
            console.error('获取稿件信息失败', error);
        });
}

const getData = async () => {
    try {
        const res = await axios.get('/gallery/');
        if (res.data && Array.isArray(res.data)) {
            ga.value = res.data.filter(item => {
                if (item.type !== 'file') return false;
                const suffix = item.name.slice(item.name.lastIndexOf('.')).toLowerCase();
                return suffixes.includes(suffix);
            }).map(item => { return 'http://img.helloworldend.top/gallery/' + item.name }).reverse()
        }
    } catch (error) {
        console.error('获取图片列表失败：', error);
    }
};

const handleRefresh = (currentPage, pagesize, id) => {
    getCommissionList(currentPage, pagesize, id);
};

const getImage = (date, sort) => {
    if (!date || !sort) return null;
    const image = ga.value.find(img => {
        return img.includes(date.replace(/-/g, '').slice(2) + '-0' + sort);
    });
    return image || null;
};

onMounted(() => {
    getData();
    getCommissionList(props.parentCurrentPage, data.value.pagesize, null);
})
</script>
<style scoped>
.uploader {
    width: 300px
}
</style>